import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { MapPin, Clock, Sprout } from "lucide-react";
import { resolveImageUrl } from "@/components/ImageUploader";

const FALLBACK = "https://images.unsplash.com/photo-1576181456177-2b99ac0aa1ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxmcmVzaCUyMG9yZ2FuaWMlMjB2ZWdldGFibGVzJTIwZmFybWVycyUyMG1hcmtldHxlbnwwfHx8fDE3ODE2MjM3MjN8MA&ixlib=rb-4.1.0&q=85";

const typeColor = {
  sale: "bg-emerald-800 text-stone-50",
  free: "bg-amber-700 text-stone-50",
  barter: "bg-stone-800 text-stone-50",
  wholesale: "bg-stone-700 text-stone-50",
};

export default function ProductCard({ product, onOrder }) {
  return (
    <div data-testid={`product-card-${product.product_id}`} className="bg-white border border-stone-200 rounded-md overflow-hidden lift flex flex-col">
      <div className="relative h-48 overflow-hidden bg-stone-100">
        <img src={resolveImageUrl(product.image_url) || FALLBACK} alt={product.title} className="w-full h-full object-cover" />
        <div className="absolute top-3 left-3 flex gap-2">
          <Badge className={`${typeColor[product.listing_type] || "bg-stone-700"} rounded-sm font-sans uppercase tracking-wider text-[10px]`}>
            {product.listing_type}
          </Badge>
          {product.category === "mutation" && (
            <Badge className="bg-amber-600 text-stone-50 rounded-sm font-sans uppercase tracking-wider text-[10px]">Mutation</Badge>
          )}
        </div>
      </div>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-serif text-xl text-stone-900 leading-tight">{product.title}</h3>
          {product.listing_type === "sale" || product.listing_type === "wholesale" ? (
            <div className="font-serif text-xl text-emerald-800 shrink-0">${product.price.toFixed(2)}</div>
          ) : (
            <div className="font-serif text-base text-amber-700 shrink-0 uppercase tracking-wider">{product.listing_type}</div>
          )}
        </div>
        <p className="text-sm text-stone-600 font-sans line-clamp-2 leading-relaxed">{product.description}</p>

        <div className="flex flex-wrap gap-3 text-xs text-stone-500 font-sans">
          <span className="flex items-center gap-1"><MapPin size={13} />{product.pickup_city}, {product.state}</span>
          <span className="flex items-center gap-1">
            {product.availability === "ready" ? <Sprout size={13} className="text-emerald-700" /> : <Clock size={13} className="text-amber-700" />}
            {product.availability === "ready" ? "Ready Now" : "Wait for Harvest"}
          </span>
        </div>

        <div className="text-xs text-stone-500 font-sans border-t border-stone-100 pt-3">
          By{" "}
          <Link
            data-testid={`farmer-link-${product.farmer_id}`}
            to={`/hobby-farmers/${product.farmer_id}`}
            className="text-stone-700 hover:text-emerald-800 underline-offset-2 hover:underline"
            onClick={(e) => e.stopPropagation()}
          >
            {product.farmer_name}
          </Link>
        </div>

        {onOrder && (
          <Button
            data-testid={`order-btn-${product.product_id}`}
            onClick={() => onOrder(product)}
            className="mt-1 bg-emerald-800 hover:bg-emerald-700 text-stone-50 rounded-md"
          >
            {product.listing_type === "free" ? "Request" : product.listing_type === "barter" ? "Propose Barter" : "Order"}
          </Button>
        )}
      </div>
    </div>
  );
}
